import { LibCategories, waitForConsent } from "src/utils/consent";
import { send } from "src/utils/fetch";
import { trackTask } from "src/utils/monitoring/events/tasks";
import { NOOM_YELP_ID } from "src/vendor/yelp";
import { registerHandler } from "../handler";

const leadUrl = `https://insight.adsrvr.org/track/pxl/?adv=${NOOM_YELP_ID}&ct=0:bvyoe77&fmt=3`;
const purchaseUrl = `https://insight.adsrvr.org/track/pxl/?adv=${NOOM_YELP_ID}&ct=0:k1x4a5d&fmt=3`;

export default function registerHandlers() {
  registerHandler("lead", () => {
    waitForConsent([LibCategories.targetingCookies]).then(() => {
      trackTask("YelpLead")
        .wrap(() => send("GET", `${leadUrl}&v=0`))
        .catch(() => {
          /* NOP */
        });
    });
  });

  registerHandler("purchase", ({ order }) => {
    waitForConsent([LibCategories.targetingCookies]).then(() => {
      trackTask("YelpPurchase")
        .wrap(() =>
          send(
            "GET",
            `${purchaseUrl}&v=${order.eltv_13_months.toFixed(3)}&orderid=${
              order.subscriptionId
            }`
          )
        )
        .catch(() => {
          /* NOP */
        });
    });
  });
}
